import { z } from "zod";

export interface DriversListResponse {
  listado: DriverListEntity[];
  totalPages: number;
  totalRecords: number;
}

export interface DriverListEntity {
  id: number;
  nombreApellido: string;
  equipos: string[];
  activo: boolean;
}

export interface DriverDetail {
  id: number;
  nombreApellido: string;
  email: string;
  usuario: string;
  equipos: EquipoEntity[];
  activo: boolean;
}

export interface EquipoEntity {
  idEquipo: number;
  nombreEquipo: string;
  patente: string;
}

export const driversFilterSchema = z.object({
  nombreApellido: z.any().optional(),
  activo: z.any().optional(),
  equipos: z.any().optional(),
});

export const driverCreationSchema = z.object({
  usuario: z.any().optional(),
  nombreApellido: z.any().optional(),
  email: z.any().optional(),
  equipos: z.array(
    z.object({
      equipoId: z.any(),
    }),
  ),
});

export const driverUpdateSchema = z.object({
  usuario: z.any().optional(),
  nombreApellido: z.any().optional(),
  email: z.any().optional(),
  activo: z.any().optional(),
  equipos: z.array(
    z.object({
      equipoId: z.any(),
    }),
  ),
});
